var detectBrowser = require('./lib/detectBrowser');

module.exports = detectBrowser(navigator.userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/detect-browser/browser.js
// module id = 7
// module chunks = 2